import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["open", "anchorRef", "placement", "modifiers", "children", "portal"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { clsx as cx } from 'clsx';
import { usePopper } from './usePopper';
import { FLIP, PREVENT_OVERFLOW } from './modifiers';
import * as styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Компонента для рендера элемента спозиционированного относительно другого элемента
 *
 * @export
 * @param {IPopperProps} { open, anchorEl, children }
 * @returns
 */
export function Popper(_ref) {
  var open = _ref.open,
    anchorRef = _ref.anchorRef,
    placement = _ref.placement,
    modifiers = _ref.modifiers,
    children = _ref.children,
    portal = _ref.portal,
    divProps = _objectWithoutProperties(_ref, _excluded);
  var host = typeof document !== 'undefined' ? document.body : null;
  var popper = usePopper({
    open: open,
    anchorRef: anchorRef,
    options: {
      placement: placement,
      modifiers: modifiers
    }
  });
  if (!host || !open) {
    return null;
  }
  var popperElement = /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, divProps), {}, {
    className: cx(styles['popper'], divProps.className),
    ref: popper.ref,
    children: children
  }));
  return portal ? /*#__PURE__*/ReactDOM.createPortal(popperElement, host) : popperElement;
}
Popper.defaultProps = {
  modifiers: [FLIP, PREVENT_OVERFLOW],
  portal: true
};